import React from 'react';

import clsx from 'clsx';

import { PASSWORD_REQUIREMENTS } from 'constants/password.constants';

import styles from './PasswordValidationPoints.module.scss';

const PasswordValidationPoints = ({ password }: { password: string }) => {
  const passwordRequirementsList = PASSWORD_REQUIREMENTS.map((requirement) => {
    return (
      <li
        key={requirement.message}
        className={clsx(styles.validationPoint, {
          [styles.successValidationPoint]: requirement.isValid(password),
        })}
      >
        {requirement.message}
      </li>
    );
  });

  return <ul className={styles.validationPoints}>{passwordRequirementsList}</ul>;
};

export default PasswordValidationPoints;
